import React from 'react';
const bonuses = [{
  num: '01',
  title: 'Kit Clase Mixta Perfecta',
  desc: 'Principiantes + avanzados en el mismo turno sin caos.',
  price: 'USD $9'
}, {
  num: '02',
  title: 'Pack Planilla 365',
  desc: 'Detecta quién está por abandonar antes de que pase.',
  price: 'USD $7'
}, {
  num: '03',
  title: 'Boxeo Listo Sin Ring',
  desc: 'Clases de calidad en parques, garajes y espacios reducidos.',
  price: 'USD $6'
}, {
  num: '04',
  title: 'Entrenador con Autoridad',
  desc: 'Scripts exactos para dirigir el grupo, corregir rápido y retener.',
  price: 'USD $8'
}, {
  num: '05',
  title: 'Seguridad & Guanteo Inteligente',
  desc: 'Protocolo completo de guanteo seguro con 12 misiones.',
  price: 'USD $7'
}, {
  num: '06',
  title: '12 Clases de Emergencia',
  desc: 'Plan B para días caóticos: pocos alumnos, sin equipo, sin energía.',
  price: 'USD $6'
}];
export function BonusSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-4" data-id="element-3">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3" data-id="element-4">
            🎁 MÁS LOS{' '}
            <span className="text-[#F97316]" data-id="element-5">6 BONOS ESTRATÉGICOS</span>
          </h2>
          <p className="text-gray-400 text-base" data-id="element-6">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10" data-id="element-7">
          {bonuses.map((bonus, i) => <div key={i} className="bg-[#1a0f00] border border-[#F97316] rounded-2xl p-6 flex flex-col" data-id="element-8">
              <div className="text-4xl font-black text-[#F97316] mb-1" data-id="element-9">
                {bonus.num}
              </div>
              <div className="text-[#F97316] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-10">
                🎁 BONO {i + 1}
              </div>
              <h3 className="text-white font-black text-lg mb-2" data-id="element-11">
                {bonus.title}
              </h3>
              <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-12">{bonus.desc}</p>
              <div className="flex items-center gap-2" data-id="element-13">
                <span className="text-gray-400 line-through text-sm" data-id="element-14">
                  {bonus.price}
                </span>
                <span className="bg-[#F97316] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-15">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="border border-[#F97316]/40 rounded-2xl p-6 text-center bg-[#0d0700]" data-id="element-16">
          <p className="text-[#F97316] text-sm font-semibold mb-1 uppercase tracking-widest" data-id="element-17">
            💰 Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-18">
            <span className="text-gray-400 line-through text-lg" data-id="element-19">USD $43</span>
            <span className="text-[#F97316] text-2xl font-black tracking-wide" data-id="element-20">
              🎁 GRATIS — Incluidos siempre en las dos ofertas
            </span>
          </div>
        </div>
      </div>
    </section>;
}